import React from 'react';

// Lucide-style stroked SVG icons — 24×24 canvas, currentColor stroke.
// Use `size` to scale; `className` inherits color (default: --grx-neon via CSS).
const PATHS = {
  home: (
    <>
      <path d="M3 10.5 12 3l9 7.5" />
      <path d="M5 9.5V21h14V9.5" />
      <path d="M10 21v-6h4v6" />
    </>
  ),
  invest: (
    <>
      <path d="M3 20h18" />
      <path d="M6 20V11" />
      <path d="M11 20V6" />
      <path d="M16 20v-6" />
      <path d="M21 20V9" />
      <path d="m6 8 5-4 4 3 6-5" />
    </>
  ),
  team: (
    <>
      <circle cx="9" cy="8" r="3.2" />
      <path d="M2.5 20c.7-3.4 3.4-5 6.5-5s5.8 1.6 6.5 5" />
      <circle cx="17" cy="9" r="2.5" />
      <path d="M15 15c.8-.4 1.7-.6 2.5-.6 2.4 0 4.3 1.3 4.9 3.6" />
    </>
  ),
  rank: (
    <>
      <path d="M6 3h12v4a5 5 0 0 1-6 5 5 5 0 0 1-6-5V3Z" />
      <path d="M6 5H3a2 2 0 0 0 2 4h.5" />
      <path d="M18 5h3a2 2 0 0 1-2 4h-.5" />
      <path d="M12 12v4" />
      <path d="M8 21h8" />
      <path d="M9 17h6l-.5 4h-5L9 17Z" />
    </>
  ),
  swap: (
    <>
      <path d="M4 8h13" />
      <path d="m13 4 4 4-4 4" />
      <path d="M20 16H7" />
      <path d="m11 12-4 4 4 4" />
    </>
  ),
  contributor: (
    <>
      <path d="M20 12v10H4V12" />
      <path d="M22 7H2v5h20V7Z" />
      <path d="M12 22V7" />
      <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7Z" />
      <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7Z" />
    </>
  ),
  admin: (
    <>
      <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
      <path d="M19.4 15a1.7 1.7 0 0 0 .3 1.9l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.9-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.9.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.9 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.9l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.9.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.9-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.9V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1Z" />
    </>
  ),
  copy: (
    <>
      <rect x="9" y="9" width="12" height="12" rx="2" />
      <path d="M5 15V5a2 2 0 0 1 2-2h10" />
    </>
  ),
  wallet: (
    <>
      <path d="M20 12V7H5a2 2 0 0 1 0-4h13v4" />
      <path d="M4 5v14a2 2 0 0 0 2 2h15v-5" />
      <path d="M22 12h-5a2 2 0 0 0 0 4h5v-4Z" />
    </>
  ),
  arrowRight: (<path d="m9 6 6 6-6 6" />),
  arrowLeft:  (<path d="m15 6-6 6 6 6" />),
  check: (<path d="M20 6 9 17l-5-5" />),
  x:     (<><path d="M18 6 6 18" /><path d="m6 6 12 12" /></>),
  logout: (
    <>
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <path d="m16 17 5-5-5-5" />
      <path d="M21 12H9" />
    </>
  ),

  // ── Stat-card icons ─────────────────────────────
  chartBar: (
    <>
      <path d="M3 3v18h18" />
      <rect x="7"  y="11" width="3" height="7" rx="0.5" />
      <rect x="12" y="7"  width="3" height="11" rx="0.5" />
      <rect x="17" y="4"  width="3" height="14" rx="0.5" />
    </>
  ),
  trendingUp: (
    <>
      <path d="M3 17 9 11l4 4 8-9" />
      <path d="M14 6h7v7" />
    </>
  ),
  sparkle: (
    <>
      <path d="M12 3v6" />
      <path d="M12 15v6" />
      <path d="M3 12h6" />
      <path d="M15 12h6" />
      <path d="m5.6 5.6 4.2 4.2" />
      <path d="m14.2 14.2 4.2 4.2" />
      <path d="m18.4 5.6-4.2 4.2" />
      <path d="m9.8 14.2-4.2 4.2" />
    </>
  ),
  gift: (
    <>
      <path d="M20 12v10H4V12" />
      <path d="M22 7H2v5h20V7Z" />
      <path d="M12 22V7" />
      <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7Z" />
      <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7Z" />
    </>
  ),
  users: (
    <>
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.85" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </>
  ),
  userPlus: (
    <>
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M19 8v6" />
      <path d="M22 11h-6" />
    </>
  ),
  dollar: (
    <>
      <path d="M12 2v20" />
      <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 1 1 0 7H6" />
    </>
  ),
  calendar: (
    <>
      <rect x="3" y="4" width="18" height="17" rx="2" />
      <path d="M16 2v4" />
      <path d="M8 2v4" />
      <path d="M3 10h18" />
    </>
  ),
  activity: (
    <>
      <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
    </>
  ),
  link: (
    <>
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
      <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
    </>
  ),
  crown: (
    <>
      <path d="M3 18h18l-2-11-5 4-4-7-4 7-5-4-2 11Z" />
      <path d="M3 22h18" />
    </>
  ),
  layers: (
    <>
      <path d="m12 2 10 6-10 6L2 8l10-6Z" />
      <path d="m2 16 10 6 10-6" />
      <path d="m2 12 10 6 10-6" />
    </>
  ),
  briefcase: (
    <>
      <rect x="2" y="7" width="20" height="14" rx="2" />
      <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
      <path d="M2 13h20" />
    </>
  ),
  target: (
    <>
      <circle cx="12" cy="12" r="9" />
      <circle cx="12" cy="12" r="5" />
      <circle cx="12" cy="12" r="1.5" />
    </>
  ),
  history: (
    <>
      <path d="M3 12a9 9 0 1 0 3-6.7L3 8" />
      <path d="M3 3v5h5" />
      <path d="M12 7v5l3 2" />
    </>
  ),
  gauge: (
    <>
      <path d="M12 21a9 9 0 1 1 9-9" />
      <path d="M12 12 8 8" />
      <circle cx="12" cy="12" r="1.5" />
    </>
  ),
};

const Icon = ({ name, size = 20, strokeWidth = 1.8, className = '', style = {} }) => {
  const p = PATHS[name];
  if (!p) return null;
  return (
    <svg
      className={'grx-icon ' + className}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={style}
    >
      {p}
    </svg>
  );
};

export default Icon;
